// extracted by mini-css-extract-plugin
export default {"text":"Loading_text__8F6x5","hideText":"Loading_hideText__wyitn","loader":"Loading_loader__JihcM","drawLine":"Loading_drawLine__CYW66","pencilRot":"Loading_pencilRot__5-boo"};